import {
  BonusTransfer,
  CompanyInfo,
} from "Store/interfaces/CompanyTransferSpecifications";

import { ConstEnum } from "Utils/types";
import { BaseVehicleWithBonusProduct } from "./BaseVehicleWithBonusProduct";

export const RENTAL_TYPE_VARIABLE = {
  NONE: "NONE",
  RENTAL_TYPE_ORDINARY: "RENTAL_TYPE_ORDINARY",
  RENTAL_TYPE_EXTENDED: "RENTAL_TYPE_EXTENDED",
} as const;

export type AutoRentalTypeVariable = ConstEnum<typeof RENTAL_TYPE_VARIABLE>;

export interface BaseCarProduct extends BaseVehicleWithBonusProduct {
  readonly type: string;
  readonly usedByYoungerDriver: boolean;
  readonly rentalType?: AutoRentalTypeVariable | null;
  readonly yearlyKmNeed?: number;
  readonly mileage?: number;
  readonly hasAutoIdentificationNumber: boolean;
  readonly licensePlateNumberProvided: boolean;
  readonly autoIdentificationNumber?: string;
  readonly importAndCustomsCleared?: boolean;
  readonly leasingCompany?: CompanyInfo;
  readonly driveSmart?: boolean;
  readonly driveSmartSupported?: boolean;
  readonly elCarUnionMembershipMail?: string;
  readonly bonusPreOwnership?: BonusTransfer;
  readonly greenLicensePlateColor?: boolean;
  readonly commercialVehicle?: boolean;
}
